module.exports = __webpack_public_path__ + "static/media/BgHome.a6fb583b.png";